module.exports = __webpack_public_path__ + "static/media/prizm-daily.ffa14eda.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/screens/prizm/prizm-daily.mp4
// module id = 3549
// module chunks = 0